import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { appEnv } from '../config';
import { firebaseConfig } from './config';
const firestoreDbName = firebaseConfig[appEnv]?.firestoreDbName;
export const firebase = initializeApp(firebaseConfig[appEnv]);
export const firestore = firestoreDbName ? getFirestore(firebase, firestoreDbName) : getFirestore(firebase);
